import { ReactElement, ReactNode } from "react";

export default function UserForm(props: {
  children?: ReactNode;
}): ReactElement {
  return <form className="mt-8">{props.children}</form>;
}
